module.exports = __webpack_public_path__ + "img/paypal.2f15e871.png";